import { graphql } from 'src/gql';

export const ClientsTagsFragment = graphql(/* GraphQL */ `
  fragment ClientsTags on Household {
    householdTags {
      id
      organizationHouseholdTag {
        id
        name
        isSmart
        organizationHouseholdCategory {
          id
          name
          hexColorCode
          emoji
        }
      }
    }
  }
`);

export const HouseholdClientFragment = graphql(/* GraphQL */ `
  fragment HouseholdClient on Household {
    id
    name
    salesforceAccountId
    savvyAum
    advisorAnnualRevenue
    lastContactAt
    outstandingServiceCalendarItemCount
    outstandingServiceCatalogTaskCount
    nextServiceItemDate @include(if: $serviceCalendarV2)
    clientReviewDueThisQuarter
    commentSummary {
      state
      totalCount
      unreadCount
    }
    demo
    advisor {
      id
      user {
        id
        firstName
        lastName
        profilePicUrl
        email
      }
    }
    primaryClient {
      id
      user {
        id
        firstName
        lastName
        email
        phoneNumber
      }
    }
    coClient {
      id
      user {
        id
        firstName
        lastName
        email
        phoneNumber
      }
    }
    ...ClientsTags
  }
`);
